import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Box, Button, Stack, Typography } from "@mui/material";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";

const Image = styled.img`
  width: 100%;
`;

const SuccessPageContent: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isPatient = useSelector(
    (state: RootState) => state.auth.user?.isPatient,
  );

  const navigateToDashboard = () => {
    navigate(isPatient ? "/portal" : "/");
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      padding="16px"
      width="100%"
      boxSizing="border-box"
    >
      <Stack
        width="500px"
        height="100%"
        alignItems="center"
        justifyContent="center"
      >
        <Image src={`${process.env.PUBLIC_URL}/images/success-img.png`} />

        <Typography
          fontSize="32px"
          lineHeight="48px"
          fontWeight="500"
          color="#171A1FFF"
          marginTop="32px"
        >
          {t("onboardingSuccess.title")}
        </Typography>

        <Typography
          fontSize="16px"
          lineHeight="26px"
          fontWeight="400"
          color="#171A1FFF"
          marginTop="12px"
        >
          {t("onboardingSuccess.subtitle")}
        </Typography>

        <Box marginTop="32px" width="100%">
          <Button
            variant="contained"
            color="primary"
            onClick={navigateToDashboard}
            size="large"
            fullWidth
          >
            <Typography>{t("onboardingSuccess.getStartedButton")}</Typography>
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

export default SuccessPageContent;
